module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-8.b232a794.jpg";